module.exports = "<div class=\"card card-red-tint\" ng-repeat=\"(url, message) in errors.data\" ng-if=\"message.error || message.details\">\n    <div ng-bind-html=\"message.error\"></div>\n    <div><small ng-bind=\"message.details\"></small></div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./project/directives/status-message/status-row/status-row.html
// module id = 842
// module chunks = 3